import {defaultDataIdFromObject, StoreObject} from '@apollo/client';

/**
 * Runs should be identified by api ID
 */
export default function dataIdFromRunObject(
  responseObject: Readonly<StoreObject>
): string | null | undefined {
  if (responseObject.__typename === 'RunNode') {
    return defaultDataIdFromObject({__typename: responseObject.__typename, id: responseObject.apiId});
  }
  return undefined;
}
